import CorModel from "../models/corModel";

import { iServiceCached } from "./base/iServiceCached";

class CorService extends iServiceCached<CorModel> {
    constructor() {
        super("Cor");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
        }));
    }
}
export default new CorService();
